import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardRecidiviService from "./dashboardRecidiviService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import { validEmail, validPassword } from "../../../common/utils";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
// import user from '../../../mokup_ListaUser'

toast.configure();

class dashboardRecidivi extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      showModalSanzioniRecidivo: false,
      dataTableSanzione: [],
      dataTableSanzioneCSV: [],
      csvFile: [],
      headerDataTableSanzione: [],
      searchNumSanzione: "",
      searchDataEmissione: "",
      searchNome: "",
      searchCognome: "",
      searchCF: "",
      loading: true,
      showModalModificaUser: false,
      selectRoleOption: false,
      isErrornumMatricola: false,
      isErrorPassword: false,
      isErrorEmail: false,
      isErrorNome: false,
      isErrorCognome: false,
      isErrorRuolo: false,
      recidivi: [
        {
          nome: "",
          cognome: "",
          cf: "",
          nSanz: 0,
          listaDiDettaglioSanzioni: [
            {
              numSanzione: "",
              dataEmissione: 0,
              statoSanzione: "",
              idSanzione: 0,
            },
          ],
        },
      ],
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    const emailRegex = /^\S+@\S+\.\S+$/;
  }

  componentDidMount() {
    sessionStorage.removeItem("ListaSaznioniRecidivo");
    this.dashboardSanzioneService = new DashboardRecidiviService();
    var search = this.props.location.search;
    var stato = "daLav";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.getDataTable(stato);
  }

  getDataTable(stato) {
    this.dashboardSanzioneService.getDataTableSanzioni(
      stato,
      this.onSuccessLoadDataTableSanzione.bind(this)
    );
  }
  onSuccessLoadDataCharter(result) {
    this.setState((this.data = result));
  }
  onSuccessLoadDataTableSanzione(resultHeader, resultBody) {
    var sanzioni = resultBody;
    var moment = require("moment");
    var numSanzioniInscadenza = 0;
    for (let i = 0; i < sanzioni.length; i++) {
      var sanzione = sanzioni[i];
      var allaScadenza = "-";
      if ("Caricato" === sanzioni[i].statoSanzione) {
        var diff = calculateTimeDifferenceTwoDates(
          new Date(),
          moment(sanzione.dataEmissione, "DD/MM/YYYY").toDate()
        );
        allaScadenza = 60 - parseInt(diff, 10);
        var val = "-";
        if (allaScadenza < 0) {
          val = "Scaduto";
          numSanzioniInscadenza += 1;
        } else {
          val = "Scade tra " + allaScadenza + " giorni";
          if (allaScadenza < 5) numSanzioniInscadenza += 1;
        }
        sanzione.giorniAllaScadenza = val;
      } else {
        sanzione.giorniAllaScadenza = " - ";
      }
    }
    // var mexError =
    //   "Attenzione " + numSanzioniInscadenza + " sanzioni in scadenza!";
    // if (numSanzioniInscadenza > 5)
    //   toast.warn(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else if (numSanzioniInscadenza > 10)
    //   toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else toast.info(numSanzioniInscadenza + " sanzioni in scadenza ");
    this.setState((this.headerDataTableSanzione = resultHeader));
    this.setState({ dataTableSanzioneCSV: resultBody });
    this.setState({ dataTableSanzione: resultBody });
    this.setState({ loading: false });
    resultBody.map((dati) => {
      this.state.csvFile = [
        ...this.state.csvFile,
        {
          nome: dati.nome,
          cognome: dati.cognome,
          cf: dati.cf,
          nSanz: dati.nSanz,
          numSanzione: dati.listaDiDettaglioSanzioni.numSanzione,
          dataEmissione: dati.listaDiDettaglioSanzioni.dataEmissione,
          statoSanzione: dati.listaDiDettaglioSanzioni.statoSanzione,
          idSanzione: dati.listaDiDettaglioSanzioni.idSanzione,
        },
      ];
    });

    this.setState({ csvFile: this.state.csvFile });
  }

  onRowClick(row) {
    sessionStorage.removeItem("ListaSaznioniRecidivo");
    sessionStorage.setItem("ListaSaznioniRecidivo", JSON.stringify(row));
    // console.log(row);//dati della righa da passare
    // this.props.history.push("/detailProfile");
    // console.log(JSON.stringify(row))
    this.setState({ showModalSanzioniRecidivo: true });
  }

  chiudiScheda() {
    sessionStorage.removeItem("ListaSaznioniRecidivo");
    this.setState({ showModalSanzioniRecidivo: false });
  }

  tabbellaSanzioniRecidivo() {
    var moment = require("moment");
    if (JSON.parse(sessionStorage.getItem("ListaSaznioniRecidivo") === null)) {
      return (
        <>
          <Modal size="lg" show={this.state.showModalSanzioniRecidivo}>
            <Modal.Header>
              <Modal.Title>Scheda Sanzioni Recidivo </Modal.Title>
            </Modal.Header>
            <Modal.Body>Nessun Dato</Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.chiudiScheda.bind(this)}
              >
                Chiudi scheda Sanzioni
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    } else {
      this.scheda = JSON.parse(sessionStorage.getItem("ListaSaznioniRecidivo"));
      //console.log(this.scheda.listaDiDettaglioSanzioni);
      return (
        <>
          <Modal size="lg" show={this.state.showModalSanzioniRecidivo}>
            <Modal.Header>
              <Modal.Title>Scheda Sanzioni Recidivo </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Numero Sanzione</th>
                    <th scope="col">Data Emissione</th>
                    <th scope="col">stato</th>
                  </tr>
                </thead>
                <tbody>
                  {this.scheda.listaDiDettaglioSanzioni[0].map((val) => {
                    return (
                      <>
                        <tr
                          onClick={() => {
                            const valoriSaznionePush = {
                              id: val.idSanzione,
                              statoSanzione: "Recidivo",
                            };
                            sessionStorage.removeItem("rowSanzione");
                            sessionStorage.setItem(
                              "rowSanzione",
                              JSON.stringify(valoriSaznionePush)
                            );
                            this.props.history.push("/detailSanzione");
                          }}
                        >
                          <td>{val.numSanzione}</td>
                          <td>{geDataFormat(val.dataEmissione)}</td>
                          <td>{val.statoSanzione}</td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.chiudiScheda.bind(this)}
              >
                Chiudi scheda Sanzioni
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    }
  }

  dataObj() {
    for (const item of this.state.dataTableSanzione) {
      item.clickEvent = () => this.onRowClick(item);
    }
    var data = {
      columns: this.headerDataTableSanzione,
      rows: this.state.dataTableSanzione,
    };
    return data;
  }

  renderTableData() {
    if (
      this.state.dataTableSanzione &&
      this.state.dataTableSanzione.length > 0
    ) {
      return (
        <CDBContainer>
          <CDBCard border>
            <CDBCardBody>
              <CDBDataTable
                sortable={false}
                responsiveSm={true}
                responsiveMd={true}
                responsiveLg={true}
                pagesAmount={3}
                entriesLabel={""}
                entries={20}
                // tbodyColor="table-warning"
                // className="table-primary"
                infoLabel={["Mostra da", "a", "di", "recidivi totali"]}
                paginationLabel={["<-", "->"]}
                striped
                bordered
                hover
                checkbox
                data={this.dataObj()}
                materialSearch
              />
            </CDBCardBody>
          </CDBCard>
        </CDBContainer>
      );
    } else {
      return <tr>Nessun recidivo presente</tr>;
    }
  }

  render() {
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Recidivi<br></br>
              <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              >
                Recidivi
              </small>
            </h1>
            <CSVLink
              data={this.state.csvFile}
              separator={";"}
              filename="recidivi.csv"
            >
              <button type="button" class="btn btn-warning">
                {" "}
                <i className="fas fa-download fa-sm text-white"></i>{" "}
                &nbsp;Esporta Recidivi
              </button>
            </CSVLink>
          </div>
          <br />
          <br />
          <div className="col">{this.renderTableData()}</div>
          {this.tabbellaSanzioniRecidivo()}
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(dashboardRecidivi);
